import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/lib/integration/react";
import { CookiesProvider } from "react-cookie";

import { persistor, store } from "./store";
import { GlobalStyles } from "./theme/globalStyles";
import GlobalConfig from "./modules/GlobalConfig";

import reportWebVitals from "./reportWebVitals";
import SessionProvider from "./providers/SessionProvider";
import SettingsProvider from "./providers/SettingsProvider";
import GtmProvider from "./providers/GtmProvider";
import LoadingModalProvider from "./providers/LoadingModalProvider";
import AffiliateProvider from "./providers/AffiliateProvider";
import ThemeProvider from "./providers/ThemeProvider";
import ErrorProvider from "./providers/ErrorProvider";
import AppRouter from "./router";
import HubSpotProvider from "./providers/HubSpotProvider";
import ClarityProvider from "./providers/ClarityProvider";
import ReferrerProvider from "./providers/ReferrerProvider";
import Message from "./components/UI/Message";
import TokenProvider from "./providers/TokenProvider";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <Provider store={store}>
      <ErrorProvider>
        <Message />
        <PersistGate persistor={persistor}>
          <GtmProvider>
            <ThemeProvider>
              <GlobalStyles />
              <GlobalConfig />
              <TokenProvider>
                <SettingsProvider>
                  <ReferrerProvider>
                    <SessionProvider>
                      <ClarityProvider>
                        <HubSpotProvider>
                          <LoadingModalProvider>
                            <CookiesProvider>
                              <AffiliateProvider>
                                <AppRouter />
                              </AffiliateProvider>
                            </CookiesProvider>
                          </LoadingModalProvider>
                        </HubSpotProvider>
                      </ClarityProvider>
                    </SessionProvider>
                  </ReferrerProvider>
                </SettingsProvider>
              </TokenProvider>
            </ThemeProvider>
          </GtmProvider>
        </PersistGate>
      </ErrorProvider>
    </Provider>
  </BrowserRouter>,
);

reportWebVitals();
